// extracted by mini-css-extract-plugin
module.exports = {"supportPolicy":"SupportPolicy_supportPolicy__mfjLL"};